/**
 * ZA Inline Cart Controls
 * AJAX add-to-cart with qty stepper on any page with [data-za-variant-id] cards.
 * Delegates on document.body so it works across homepage, collection, and search.
 */
(function () {
  var cards = document.querySelectorAll('[data-za-variant-id]');
  if (!cards.length) return;

  var busy = false;

  /* ── Cart API helpers ─────────────────────────────────── */

  function cartFetch(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error(r.statusText);
      return r.json();
    });
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  /* ── Sync cart state to all cards on page ──────────────── */

  function syncCart() {
    return getCart().then(function (cart) {
      // Update header cart count badge
      var badge = document.querySelector('[data-cart-count]');
      if (badge) {
        badge.hidden = cart.item_count === 0;
        badge.textContent = cart.item_count;
      }

      // Build variant_id → qty map
      var qtyMap = {};
      cart.items.forEach(function (item) {
        qtyMap[String(item.variant_id)] = (qtyMap[String(item.variant_id)] || 0) + item.quantity;
      });

      // Update every card on the page
      document.querySelectorAll('[data-za-variant-id]').forEach(function (actions) {
        var vid = actions.dataset.zaVariantId;
        var qty = qtyMap[vid] || 0;
        setCardState(actions, qty);
      });

      return cart;
    });
  }

  /* ── Card UI state toggle ─────────────────────────────── */

  function setCardState(actions, qty) {
    var form = actions.querySelector('form');
    var split = actions.querySelector('.za-card__split');
    var qtyEl = actions.querySelector('[data-za-qty]');
    var incBtn = actions.querySelector('[data-za-inc]');

    if (qty > 0) {
      // Show split controls, hide ATC form
      if (form) form.hidden = true;
      split.hidden = false;
      qtyEl.textContent = qty;

      // Disable + if at stock cap
      var managed = actions.hasAttribute('data-za-managed');
      var policy = actions.dataset.zaPolicy;
      var max = parseInt(actions.dataset.zaMax, 10);
      incBtn.disabled = managed && policy === 'deny' && qty >= max;
    } else {
      // Revert to ATC button
      if (form) form.hidden = false;
      split.hidden = true;
      qtyEl.textContent = '0';
      incBtn.disabled = false;
    }
  }

  /* ── Loading state ────────────────────────────────────── */

  function setBusy(actions, on) {
    actions.classList.toggle('is-loading', on);
    busy = on;
  }

  /* ── Add to cart ──────────────────────────────────────── */

  function addToCart(actions) {
    if (busy) return;
    var vid = parseInt(actions.dataset.zaVariantId, 10);
    setBusy(actions, true);

    cartFetch('/cart/add.js', { id: vid, quantity: 1 })
      .then(function () { return syncCart(); })
      .then(function () { setBusy(actions, false); })
      .catch(function () { setBusy(actions, false); });
  }

  /* ── Change qty ───────────────────────────────────────── */

  function changeQty(actions, newQty) {
    if (busy) return;
    var vid = parseInt(actions.dataset.zaVariantId, 10);
    setBusy(actions, true);

    // quantity 0 removes the item
    cartFetch('/cart/change.js', { id: String(vid), quantity: Math.max(0, newQty) })
      .then(function () { return syncCart(); })
      .then(function () { setBusy(actions, false); })
      .catch(function () { setBusy(actions, false); });
  }

  /* ── Event delegation on document.body ────────────────── */

  document.body.addEventListener('click', function (e) {
    // Add to cart
    var atc = e.target.closest('[data-za-atc]');
    if (atc) {
      e.preventDefault();
      var actions = atc.closest('[data-za-variant-id]');
      if (actions) addToCart(actions);
      return;
    }

    // Increment
    var inc = e.target.closest('[data-za-inc]');
    if (inc && !inc.disabled) {
      var actions = inc.closest('[data-za-variant-id]');
      if (!actions) return;
      var current = parseInt(actions.querySelector('[data-za-qty]').textContent, 10);
      var managed = actions.hasAttribute('data-za-managed');
      var policy = actions.dataset.zaPolicy;
      var max = parseInt(actions.dataset.zaMax, 10);
      if (managed && policy === 'deny' && current >= max) return;
      changeQty(actions, current + 1);
      return;
    }

    // Decrement
    var dec = e.target.closest('[data-za-dec]');
    if (dec) {
      var actions = dec.closest('[data-za-variant-id]');
      if (!actions) return;
      var current = parseInt(actions.querySelector('[data-za-qty]').textContent, 10);
      changeQty(actions, current - 1);
      return;
    }
  });

  /* ── Initial sync — mark cards already in cart ────────── */

  syncCart();
})();
